import { useGetStructureQuery } from '@/__generated__/graphql';
import { useRouter } from '@/hooks';
import { Box } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { PageLoader } from '../shared/PageLoader';
import { EquipmentStrategyOnboarding } from './EquipmentStrategyOnboarding';

type Props = { platformId: string };

export const EsSheetContainer = ({ platformId }: Props) => {
  const router = useRouter();

  const { data, loading } = useGetStructureQuery({
    variables: { structureId: platformId },
    skip: !platformId,
  });

  const { templateData } = useMemo(() => {
    return {
      structureName: data?.structure?.name,
      templateData: data?.structure?.templateData || [],
    };
  }, [data]);

  useEffect(() => {
    if (templateData?.length > 0) router.push(`/analysis/${platformId}/risk`);
  }, [router, platformId, templateData]);

  if (loading || templateData?.length > 0) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return <EquipmentStrategyOnboarding />;
};
